import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import "../../../assets/styles/scheduledChanges.scss";

const toDateTimeLocalValue = (value) => {
    if (!value) return "";

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const getNowDateTimeLocalValue = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const ScheduleChangeUpdateForms = ({
    values = {},
    isLoading = false,
    onChange,
    validationErrors = {},
}) => {
    const scheduledValue = toDateTimeLocalValue(values.scheduledTime);
    const rollbackValue = toDateTimeLocalValue(values.rollbackScheduledTime);
    const [nowMinValue, setNowMinValue] = React.useState(() => getNowDateTimeLocalValue());

    React.useEffect(() => {
        const intervalId = window.setInterval(() => {
            setNowMinValue(getNowDateTimeLocalValue());
        }, 30000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, []);

    const rollbackMinValue = scheduledValue || nowMinValue;

    const handleInputChange = (field) => (event) => {
        const nextValue = event.target.value;

        if (typeof onChange === "function") {
            onChange(field, nextValue);
        }
    };

    return (
        <Container fluid className="mt-4 w-100">
            <Form>
                <Row className="g-3 scheduled-filters-row">
                    <Col xs={12} className="scheduled-filters-col">
                        <Form.Group controlId="scheduledTime">
                            <Form.Label className="fw-bold">Data zaplanowania</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                value={scheduledValue}
                                min={nowMinValue}
                                isInvalid={Boolean(validationErrors?.scheduledTime)}
                                disabled={isLoading}
                                placeholder="Brak daty zaplanowania"
                                onChange={handleInputChange("scheduledTime")}
                            />
                            {validationErrors?.scheduledTime && (
                                <Form.Text className="text-danger d-block mt-1">
                                    {validationErrors.scheduledTime}
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Col>

                    <Col xs={12} className="scheduled-filters-col">
                        <Form.Group controlId="rollbackScheduledTime">
                            <Form.Label className="fw-bold">Data wycofania</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                value={rollbackValue}
                                min={rollbackMinValue}
                                isInvalid={Boolean(validationErrors?.rollbackScheduledTime)}
                                disabled={isLoading}
                                placeholder="Brak daty wycofania"
                                onChange={handleInputChange("rollbackScheduledTime")}
                            />
                            {validationErrors?.rollbackScheduledTime && (
                                <Form.Text className="text-danger d-block mt-1">
                                    {validationErrors.rollbackScheduledTime}
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
};

export default ScheduleChangeUpdateForms;